import classnames from 'classnames';
import PropTypes from 'prop-types';
import Checkbox from '../../../../Checkbox';
import Radio from '../../../../Radio';
import {useEffect, useState} from 'react';

import './style.scss';

const DataLayerControl = ({
	active,
	data,
	layerTemplate,
	onAdd,
	onMount,
	onRemove,
	showDescriptionInTitle,
	type = 'checkbox',
	attribute,
	initialized = true,
	removeable = false,
}) => {
	const [loading, setLoading] = useState(false);
	const [initializedLayer, setInitializedLayer] = useState(initialized);
	useEffect(() => {
		if (typeof onMount === 'function') {
			onMount();
		}
	}, []);

	const classes = classnames('unhab-DataLayerControl', {
		'is-active': active,
		loading: loading,
	});

	const name =
		attribute?.data.nameDisplay ||
		layerTemplate?.data?.nameDisplay ||
		data?.nameDisplay;
	const description = layerTemplate?.data?.description;

	const addLayer = () => {
		const timeout = initializedLayer ? 0 : 150;
		if (!initializedLayer) {
			setLoading(true);
		}
		onAdd(timeout).then(() => {
			if (!initializedLayer) {
				setLoading(false);
				setInitializedLayer(true);
			}
		});
	};

	return (
		<div className={classes}>
			<div className="unhab-DataLayerControl-header">
				{type === 'radio' ? (
					<Radio
						className="unhab-DataLayerControl-name"
						checked={active}
						onChange={active ? onRemove : addLayer}
						onClick={removeable && active ? onRemove : null}
						htmlTitle={name}
					>
						{name}{' '}
						{showDescriptionInTitle ? <span>({description})</span> : null}
					</Radio>
				) : (
					<Checkbox
						className={`unhab-DataLayerControl-name ${
							loading ? ' loading' : ''
						}`}
						checked={loading ? false : active}
						disabled={loading}
						onChange={active ? onRemove : addLayer}
						htmlTitle={name}
					>
						{name}{' '}
						{showDescriptionInTitle ? <span>({description})</span> : null}
					</Checkbox>
				)}
			</div>
		</div>
	);
};

DataLayerControl.propTypes = {
	active: PropTypes.bool,
	data: PropTypes.object,
	children: PropTypes.node,
	layerTemplate: PropTypes.object,
	mapKey: PropTypes.string,
	onAdd: PropTypes.func,
	onMount: PropTypes.func,
	onRemove: PropTypes.func,
	showDescriptionInTitle: PropTypes.bool,
	type: PropTypes.string,
	attribute: PropTypes.object,
	initialized: PropTypes.bool,
	removeable: PropTypes.bool, //for radio type, remove layer after click on active
};

export default DataLayerControl;
